export const ASSET_NAME = 'privacy-policy';

export const loadData = () => () => Promise.resolve();
